import styled from 'styled-components';
import withScrolling from 'react-dnd-scrolling';
import { getColorShade, getSizeBy } from '../../../../../src/styled/utils';
import { Button } from '../../../button';
import { Toggle } from '../../../toggle';
import { SETTINGS_LABEL_WIDTH } from '../../style-constants';
import { Tooltip } from '../../../tooltip';
import { Subtitle1 } from '../../../typography';
export const ResetButton = styled(Button).attrs({
    text: 'Reset to default',
    size: 'small',
    variant: 'outline'
}) `
  margin: 8px 16px;
  white-space: nowrap;

  span {
    text-transform: inherit;
  }
`;
export const StyledColumnSettings = styled.div `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;
export const StyledColumnDndListWrap = styled.div `
  overflow: auto;
`;
const ScrollingComponent = withScrolling('div');
export const StyledSettingsRowWrapper = styled(ScrollingComponent) `
  flex-grow: 1;
  overflow-y: auto;
`;
export const StyledRow = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${getSizeBy(3)} ${getSizeBy(6)};
  color: ${getColorShade('onSurface', 'highEmphasis')};

  & + &::after {
    position: absolute;
    top: 0;
    left: 10%;
    display: block;
    width: 80%;
    height: 1px;
    background: ${getColorShade('onSurface', 'border')};
    content: '';
  }
`;
export const StyledToggle = styled(Toggle) `
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  max-width: ${SETTINGS_LABEL_WIDTH};
  margin-left: ${getSizeBy(1.5)};
`;
export const StyledLabel = styled.div `
  display: -webkit-box; /* stylelint-disable-line */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; /* stylelint-disable-line */
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const StyledTooltip = styled(Tooltip) `
  ${({ $external }) => $external}
`;
export const ListTitle = styled(Subtitle1) `
  padding: ${getSizeBy(3)} ${getSizeBy(6)};
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
`;
